export const STORAGE_KEY = 'emh_erp_v5_v2';
export const DATA_VERSION = '2026020402';
export const APP_VERSION = 'v5.0 (v2)';
export const ERP_ROOT = '/';
export const QR_BASE = 'https://b.bottlesjapan.com/';
export const USE_LOCAL_JSON = false;
export const LOCAL_JSON_PATH = './data/erp_v2.json';
export const SYNC_DEBOUNCE_MS = 800;
